import { useState, useEffect, useCallback, FormEvent } from "react";
import { Box } from "@pingux/astro";
import RepoVersions from "@components/RepoVersions";
import {
  addRepository,
  deleteRepository,
  getRepositories,
  type Repository,
} from "services";

const Dashboard: React.FC = () => {
  const [repos, setRepos] = useState<Repository[]>([]);
  const [url, setUrl] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRepos = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getRepositories();
      setRepos(data);
      setError(null);
    } catch {
      setError("Failed to load repositories");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRepos();
  }, [fetchRepos]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!url.trim()) return;

    setSubmitting(true);
    setError(null);
    try {
      await addRepository(url.trim(), description.trim() || undefined);
      setUrl("");
      setDescription("");
      await fetchRepos();
    } catch (err: any) {
      const msg = err?.response?.data?.message || "Failed to add repository";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await deleteRepository(id);
      setRepos((prev) => prev.filter((r) => r.id !== id));
    } catch {
      setError("Failed to delete repository");
    }
  };

  return (
    <Box
      sx={{
        padding: "2rem 2.5rem",
      }}
    >
      <RepoVersions />
    </Box>
  );
};

export default Dashboard;
